import { createSwiper, withResize } from '../../components/swiper-init.js';

export function initSwiperCareersWithResize() {
  withResize(() => {
    createSwiper('careers', { initialSlide: 1 });
    createSwiper('is--team', { initialSlide: 1 });
  });
}
